import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { api } from '../lib/apiClient';

const normalize=value=>String(value??'').replace(/[\u200B-\u200D\uFEFF]/g,'').trim();

function setReactInput(input,value){
  const setter=Object.getOwnPropertyDescriptor(window.HTMLInputElement.prototype,'value')?.set;
  if(setter)setter.call(input,value);else input.value=value;
}

export default function WarehouseScanAliasBridge(){
  const location=useLocation();

  useEffect(()=>{
    if(!location.pathname.startsWith('/depo/stok-hareketleri'))return undefined;

    let disposed=false;
    let translating=false;
    const aliases=new Map();

    api.get('/warehouse/items').then(({data})=>{
      if(disposed)return;
      (data?.items||[]).forEach(item=>{
        const alias=normalize(item?.scan_code).toUpperCase();
        const canonical=normalize(item?.barcode||item?.sku);
        if(alias&&canonical)aliases.set(alias,canonical);
      });
    }).catch(()=>{});

    const onInput=event=>{
      if(translating)return;
      const input=event.target;
      if(!(input instanceof window.HTMLInputElement))return;
      const placeholder=String(input.getAttribute('placeholder')||'');
      if(!/Barkod\s*\/\s*SKU|Ürün barkodu/i.test(placeholder))return;

      const raw=normalize(input.value);
      if(!raw)return;
      const canonical=aliases.get(raw.toUpperCase());
      if(!canonical||canonical===raw)return;

      translating=true;
      setReactInput(input,canonical);
      input.dispatchEvent(new Event('input',{bubbles:true}));
      input.dispatchEvent(new Event('change',{bubbles:true}));
      translating=false;
    };

    document.addEventListener('input',onInput,true);
    return()=>{
      disposed=true;
      document.removeEventListener('input',onInput,true);
    };
  },[location.pathname]);

  return null;
}
